export const referentiel = {
  Comptes: {
    fiche: {
      titles: {
        edit_title: 'Fiche du compte {{code}} - {{iban}}',
        new_title: "Création d'un nouveau compte",
        view_title: 'Fiche du compte',
        bank_infos: 'Coordonnées bancaires',
        settings: 'Paramétrage',
        plus_infos: 'Informations complémentaires',
        accounting_zone: 'Zones comptables',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        history: 'Historique',
        close: 'Fermer',
      },
      tabs: {
        flow: 'Flux',
        check: 'Chèque',
        account: 'Compta',
        contacts_agence: 'Contacts agence',
      },
      champ_titles: {
        company: 'Société',
        code: 'Code',
        state: 'Etat',
        name: 'Nom',
        country: 'Pays',
        account_num: 'N° de compte',
        bic: 'BIC',
        bank: 'Banque',
        devise: 'Devise',
        domiciliation: 'Domiciliation',
        emetteur: 'Autorisé compte émetteur',
        tiers: 'Autorisé compte tiers',
        custom: {
          custom_1: 'Custom1',
          custom_2: 'Custom2',
          custom_3: 'Custom3',
          custom_4: 'Custom4',
          custom_5: 'Custom5',
        },
        balance_continuity_check: 'Continuité date de solde',
        alternative_account: 'N° compte alternatif',
        sender_code: 'N° émetteur',
        sender_code_vcom: 'N° émetteur VCOM',
        fileformat: 'FileFormat relevé de compte',
        number_next: 'Prochain N° chèque',
        number_end: 'Dernier N° chèque',
        cmc7_1: 'Ligne CMC7 1',
        cmc7_2: 'Ligne CMC7 2',
        account_info: 'Information compte',
        zone_payable: 'Zone "Payable" du chèque',
        accounting: 'Compte Comptable',
        journal: 'Code Journal',
        auxiliary: 'Compte Auxiliaire',
        customize1: 'Custom1',
        customize2: 'Custom2',
        customize3: 'Custom3',
        customize4: 'Custom4',
        customize5: 'Custom5',
        customize6: 'Custom6',
        customize7: 'Custom7',
        customize8: 'Custom8',
        customize9: 'Custom9',
        customize10: 'Custom10',
        default_placeholder: '<Contact agence principal par défaut>',
        contact_agence: 'Contact Agence',
        contactFlux: 'Contact Flux',
        contactPouvoir: 'Contact Pouvoir',
        autorise_operation: 'Autorisé Opération de change',
      },
    },
    table: {
      header: {
        title: 'Liste des comptes',
        new_account: 'Nouveau',
      },
      filters: {
        state: '-Etat-',
      },
      searchInput: {
        caption: 'Rechercher un compte par code, nom ou société',
      },
      buttons: {
        rib_print: 'Imprimer RIB',
      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        bank: 'Banque',
        iban: 'IBAN',
        company: 'Société',
        pays: 'Pays Banque',
        devise: 'Devise',
        date: 'Date de modification',
      },
    },
  },
  Echéancier: {
    fiche: {
      title: {
        edit_title: 'Fiche du format {{code}}',
        view_title: "Fiche d'un échénacier",
        new_title: "Création d'un nouvel échéancier",
        date_manage: 'Gestion Date',
        mandate: 'Mandat',
        flow_custom: 'Champs de flux customisé',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
      },
      champ_titles: {
        mandate: 'Mandat',
        flow: 'Flux',
        value_date: 'Date de valeur',
      },
    },
    table: {
      header: {
        title: 'Liste des échéanciers',
        new_timeline: 'Nouveau',
      },
      columns: {
        state: 'Etat',
        company_rum: 'Société/RUM',
        code_tiers: 'Tiers débiteur',
        nom_tiers: 'Nom tiers débiteur',
        amount: 'Montant',
        reason: 'Motif',
        expiry_date: 'Date 1ere échéance',
        next_expiry_date: 'Date prochaine échéance',
        last_expiry_date: 'Date dernière échéance',
        periodicity: 'Périodicité',
        flow: 'Flux',
      },
    },
  },
  GroupesTiers: {
    fiche: {
      title: {
        edit_title: 'Fiche du groupe',
        view_title: 'Fiche du groupe {{code}}',
        new_title: "Création d'un nouveau groupe",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
      },
      champ_titles: {
        name: 'Nom',
        code: 'Code',
      },
    },
    table: {
      header: {
        title: 'Liste des groupes de tiers',
        new_thirdpartygroup: 'Nouveau',
      },
      columns: {
        code: 'Code',
        name: 'Nom',
        date: 'Date de modification',
      },
    },
  },
  Mandats: {
    fiche: {
      title: {
        edit_title: 'Fiche du mandat {{variable}}',
        view_title: 'Fiche du mandat {{variable}}',
        new_title: "Création d'un nouveau mandat",
        contact: 'Contact',
        amendments: 'Amendements',
        doc: 'Documents',
        history: 'Historique',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        new: 'Nouveau',
        create: 'Créer',
      },
      modal: {
        title: {
          doc: 'Document',
        },
        buttons: {
          join: 'Joindre',
          cancel: 'Annuler',
        },
        champ_titles: {
          doc_type: 'Type de document',
          doc_name: 'Nom document',
          state: 'Etat',
          start_date: 'Date de début',
          end_date: 'Date de fin',
          pdf_doc: 'Document',
          type: 'Type',
        },
        pdf_file_message:
          'Merci de sélectionner un fichier justificatif au format pdf',
        doc_type: 'Vous devez renseigner le type du document.',
        doc_name: 'Vous devez renseigner le nom du document.',
      },
      columns: {
        status: 'Statut',
        state: 'Etat',
        withdrawal_date: 'Date prélèvement',
        unpaid_date: 'Date impayés',
        reason: 'Motif',
        representation: 'Représentation',
        amount: 'Montant',
        reference: 'Reférence',
        start_date: 'Date Début',
        end_date: 'Date Fin',
        date: 'Date',
        doc_name: 'Nom Document',
        doc_type: 'Type Document',
        visualisation: 'Visualisation',
      },
      champ_titles: {
        company: 'Société',
        internal_code: 'Code interne',
        descrip: 'Description du contrat',
        interne: 'Référence interne',
        state: 'Etat',
        rum: 'Référence Unique du Mandat (RUM)',
        payment: 'Paiement',
        NumContrat: 'N° contrat',
        email: 'Email',
        fax: 'Fax',
        name: 'Nom',
        first_name: 'Prénom',
        payment_type: 'Type de paiement',
        mandate_type: 'Type de mandat',
        sequence_type: 'Type de séquence',
        creation_date: 'Date de création',
        closing_date: 'Date de fermeture',
        signature_date: 'Date de signature',
        third_party_code: 'Code tiers débiteur',
        third_party_name: 'Nom tiers débiteur',
        prev_rum: 'Ancien RUM',
        updated_state: 'Etat Mandat modifié',
      },
    },
    table: {
      header: {
        title: 'Liste des mandats',
        new_mandat: 'Nouveau',
      },
      columns: {
        state: 'Etat',
        company_rum: 'Société/RUM',
        type: 'Type',
        sequence: 'Séquence',
        signing: 'Signature',
        code_tiers: 'Tiers débiteur',
        nom_tiers: 'Nom tiers débiteur',
        code: 'Code',
      },
    },
  },
  Scopes: {
    fiche: {
      title: {
        edit_title: 'Fiche du scope {{name}}',
        view_title: 'Fiche du scope {{name}}',
        new_title: "Création d'un nouveau scope",
        user_member_list: 'Liste des utilisateurs membres',
        companies_member_list: 'Liste des sociétés membres',
        accounts_member_list: 'Liste des comptes membres',
        tiersGrp_member_list: 'Liste des groupes de tiers membres',
        list_flux: 'Liste des flux',
      },
      modal: {
        user_list: "Sélection d'utilisateurs",
        company_list: 'Sélection de sociétés',
        account_list: 'Sélection de comptes',
        third_party_group_list: 'Sélection de groupe de tiers',
        flux_list: 'Sélection de flux',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        add: 'Ajouter',
        close: 'Annuler',
        history: 'Historique',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        first_name: 'Prénom',
        state: 'Etat',
        new: 'Nouveau',
        iban: 'IBAN',
      },
    },
    table: {
      header: {
        title: 'Liste des scopes',
        new_scope: 'Nouveau',
      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        date: 'Date de modification',
        flux: 'Flux',
        devise: 'Devise',
      },
    },
  },
  Societes: {
    fiche: {
      title: {
        edit_title: 'Fiche de la société {{name}}',
        new_title: "Création d'une nouvelle société",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        history: 'Historique',
      },
      champ_titles: {
        title_adress: 'Adresse de la société',
        title_infos_complet: 'Informations complèmentaires',
        button_charge_adress_structure: 'Charger adresse structurée',
        title_adress_structure: 'Adresse structurée de la société',
        name: 'Nom',
        code: 'Code',
        fax_num: 'N° Fax',
        tel_num: 'N° Téléphone',
        legal_infos: 'Informations légales',
        state: 'Etat',
        adresse: 'Adresse',
        country: 'Pays',
        cloture_date: 'Date de clôture',
        logo: 'Logo',
        date: 'Date de modification',
        capital: 'Capital',
        capital_currency: 'Devise Capital',
        title_list_mandant: 'Liste des mandants',
        ordre: 'Ordre',
        type_mandat: 'Type Lien Mandant',
        mandat_name: 'Nom Mandant',
        fonction: 'Fonction',
        date_start: 'Date début',
        date_end: 'Date fin',
        long_name: 'Nom Long',
        tva: 'N° TVA',
        form_legacy: 'Forme Juridique',
      },
      columns: {
        state: 'Etat',
      },
      modal_mandant: {
        title: 'Fiche Mandant',
        ordre: 'Ordre',
        type_mandat: 'Type Lien Mandant',
        mandat_name: 'Mandant',
        nomination: 'Nomination',
        comment: 'Commentaire',
        date_start: 'Date début',
        date_end: 'Date fin',
        type_mandant: 'Type mandant',
        function: 'Fonction',
        modal_add_user: {
          title: "Sélection d'un utilisateur",
          state: 'Etat',
          login: 'Login',
          name: 'Nom',
          last_name: 'Prénom',
        },
        modal_add_society: {
          title: "Sélection d'un société",
          state: 'Etat',
          name: 'Nom',
          code: 'Code',
          society: 'Société',
        },
      },
    },
    drawer: {
      title: 'Gestion',
      gestion_fx: 'Gestion FX',
      companyb2b: 'Société B2B',
      holdingb2b: 'Holding B2B',
    },
    table: {
      header: {
        title: 'Liste des sociétés',
        new_company: 'Nouveau',
      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        date: 'Date de modification',
        ics: 'ICS',
        country: 'Pays',
      },
    },
  },
  Tiers: {
    fiche: {
      title: {
        title_adress: 'Adresse banque',
        title_adress_structure_banque: 'Adresse structurée banque',
        title_adress_tiers: 'Adresse tiers',
        title_adress_structure_tiers: 'Adresse structurée tiers',
        title_adress_bank_intermediaire: 'Adresse banque intermediaire',
        title_adress_structure_bank_intermediare:
          'Adresse structurée banque intermediaire',
        edit_title: 'Fiche du tiers',
        view_title: 'Fiche du tiers {{lastname}}',
        new_title: "Création d'un nouveau tiers",
        bank_infos: 'Coordonnées bancaires',
        third_address: 'Adresse du tiers',
        intermediate_bank: 'Banque intermédiaire',
        text_lecture_seule: 'Lecture seule - Modification 4Yeux en attente',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
        checkAccount: 'Vérifier le compte',
        checkBic: 'Vérifier le Bic',
      },
      champ_titles: {
        grp: 'Groupe',
        state: 'Etat',
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        siret: 'SIRET',
        tva: 'TVA',
        country: 'Pays',
        account_num: 'N° de compte',
        devise: 'Devise',
        clearing: 'Clearing',
        clearing_id: 'Clearing code / Bank code',
        domiciliation: 'Domiciliation',
        adresse: 'Adresse',
        country_code: 'Code Pays',
        prenom: 'Prénom',
        birth_date: 'Date de naissance',
        country_birth: 'Pays de naissance',
        city_birth: 'Ville de naissance',
        mail: 'Email',
        tiersType: 'Type de paiement tiers',
      },
      list_operation: {
        title: 'Liste des opérations',
        button_title: 'Activités',
        montant: 'Montant',
        currency: 'Devise',
        date: "Date d'opération",
        label: 'Libellé',
        lot_number: 'N° lot',
        remittance_number: 'N° remise',
        flow: 'Flux',
        onglet_operation: 'Opération',
        onglet_mandat: 'Mandat',
        onglet_timeline: 'Echéancier',
        onglet_analyse: 'Analyse',
        button_contre_appel: 'Contre-appel',
        title_commentaire_panel: 'Commentaire',
        confirm_message:
          'Confirmez-vous avoir effectué le contre-appel de ce Tiers ?',
      },
    },
    table: {
      header: {
        title: 'Liste des tiers',
        new_third: 'Nouveau',
      },
      columns: {
        state: 'Etat',
        type: 'Type',
        code: 'Code',
        name: 'Nom',
        account_num: 'N° de compte',
        devise: 'Devise',
        grp: 'Groupe',
        country: 'Pays',
        date: 'Date de modification',
        control: 'Contrôle',
        thirdparty_country_code: 'Pays Tiers',
        siret: 'SIRET',
        tva: 'TVA',
        type_payement: 'Type de paiement',
      },
    },
  },
  validation4Yeux: {
    title: 'Sélection des valideurs 4 Yeux',
    alert: 'Merci de sélectionner un valideur 4Yeux',
    columns: {
      login: 'Login',
      last_name: 'Nom',
      first_name: 'Prénom',
    },
  },
  Bank: {
    invalidIBAN:
      'IBAN non valide .Format : {{default_form}}, Exemple: {{example}}',
    invalidBIC: 'Le champ doit contenir 8 ou 11 caractères',
    invalidBBAN:
      'BBAN non valide. Format : {{default_form}}, Exemple: {{example}}',
    bbanInfos: ' Format : {{default_form}}, Exemple: {{example}}',
    invalidIBAN_simple: 'IBAN non valide',
    invalidBBAN_simple: 'BBAN non valide',
  },
}
